export { default } from './ExpansionPanelDetails';